<div
    class="file"
    style="height: 100%"
    fxLayout="row"
    fxLayoutAlign="start center"
>
    <!-- <div fxLayout="row" fxLayoutAlign="start center"> -->
        <div class="icon unselectable pi-16" fxFlex="10">
            <mat-icon class="dms-mat-icon-color">{{ File.IconName }}</mat-icon>
        </div>
        <div
            fxLayout="column"
            fxFlex="70"
            class="document-title text-truncate unselectable"
            [ngClass]="{ 'selected-text': Selected }"
        >
            <!-- {{ File?.Name.length > 24 ? (File?.Name | slice: 0:24) + ".." : File?.Name }} -->
            <div>{{ File?.Name | truncate: 18  }}</div>

        </div>
        <div fxLayout="column" fxLayoutAlign="start start" fxFlex="10">
            <mat-icon
                *ngIf="
                    File.SharedByUserName &&
                    dmsConfig.viewSharedDoc &&
                    !dmsConfig.viewMyDoc
                "
                class="mt-4"
                style="color: rgba(0, 0, 0, 0.6); z-index: 99 !important"
                matTooltip="Shared by: {{ File.SharedByUserName }}"
                >info</mat-icon>
    

        </div>
        <div  fxLayout="row" fxLayoutAlign="end center" fxFlex="10">
            <mat-icon
                class="material-icons mr-12 dms-mat-icon-color"
                (click)="downloadLink(File)"
                >file_download</mat-icon
            >
        </div>


    <div *ngIf="dmsConfig.useMAAPPView" class="file-publish-date mr-16" fxFlex="100" fxLayoutAlign="end center">
            {{ ("PUBLISHED_ON" | translate) + " " + (File.PublishedOn | date: 'dd.MM.yyyy')}}
    </div>
    <div *ngIf="dmsConfig.myDocumentsView" class="file-publish-date mr-16" fxFlex="100" fxLayoutAlign="end center">
            {{ ("UPLOADED_ON" | translate) + " " + (File.CreateDate | date: 'dd.MM.yyyy')}}
    </div>
</div>
